// extracted by mini-css-extract-plugin
export default {"contents":"xD-z","sectionHeading":"yD-z"};